import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: '',
    success: false,
    atsAgreementData: [],
    signedUploadLoading: false,
};

export const AtsAgreementReducer = function (state = initialState, action) {
    switch (action.type) {
        // GET
        case ActionTypes.ATS_AGREEMENT_GET_REQUEST:
            return { ...state, isLoading: true, error: false, success: false };
        case ActionTypes.ATS_AGREEMENT_GET_SUCCESS:
            return { ...state, isLoading: false, success: true, atsAgreementData: action.payload?.data?.data };
        case ActionTypes.ATS_AGREEMENT_GET_ERROR:
            return { ...state, isLoading: false, error: action?.payload?.hasError, errorMessage: action.payload?.data?.error?.[0]?.message };

        // ADD
        case ActionTypes.ATS_AGREEMENT_ADD_REQUEST:
            return { ...state, isLoading: true, error: false, success: false };
        case ActionTypes.ATS_AGREEMENT_ADD_SUCCESS:
            return { ...state, isLoading: false, success: true, successMessage: action.payload?.message };
        case ActionTypes.ATS_AGREEMENT_ADD_ERROR:
            return { ...state, isLoading: false, error: action?.payload?.hasError, errorMessage: action.payload?.data?.error?.[0]?.message };

        // UPDATE
        case ActionTypes.ATS_AGREEMENT_UPDATE_REQUEST:
            return { ...state, isLoading: true, error: false, success: false };
        case ActionTypes.ATS_AGREEMENT_UPDATE_SUCCESS:
            return { ...state, isLoading: false, success: true, successMessage: action.payload?.message };
        case ActionTypes.ATS_AGREEMENT_UPDATE_ERROR:
            return { ...state, isLoading: false, error: action?.payload?.hasError, errorMessage: action.payload?.data?.error?.[0]?.message };

        // DELETE
        case ActionTypes.ATS_AGREEMENT_DELETE_REQUEST:
            return { ...state, isLoading: true, error: false, success: false };
        case ActionTypes.ATS_AGREEMENT_DELETE_SUCCESS:
            return { ...state, isLoading: false, success: true, successMessage: action.payload?.message };
        case ActionTypes.ATS_AGREEMENT_DELETE_ERROR:
            return { ...state, isLoading: false, error: action?.payload?.hasError, errorMessage: action.payload?.data?.error?.[0]?.message };

        // UPLOAD SIGNED COPY
        case ActionTypes.ATS_AGREEMENT_UPLOAD_SIGNED_REQUEST:
            return { ...state, signedUploadLoading: true, error: false };
        case ActionTypes.ATS_AGREEMENT_UPLOAD_SIGNED_SUCCESS:
            return { ...state, signedUploadLoading: false };
        case ActionTypes.ATS_AGREEMENT_UPLOAD_SIGNED_ERROR:
            return { ...state, signedUploadLoading: false, error: true };

        default:
            return state;
    }
};
